import * as THREE from 'three';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js'
import { VRMLLoader } from 'three/examples/jsm/loaders/VRMLLoader.js';
import { FikoObje3D } from './FikoObje3D';
import { FikoSahne } from './FikoSahne';
import { FikoCizimWRL } from './FikoThreeCam/FikoCizimWRL';
import { FikoVektor3D } from './FikoVektor3d';
import { FikoWasmBridge } from './fiko-performance/FikoWasmBridge';
import { FikoThreeJsComponent } from '..';
import { getGPUImportPipeline } from './fiko-performance/FikoGPUImportPipeline';


export interface FikoWRLHiyerarsi {
    name: string;
    type: string;
    children?: FikoWRLHiyerarsi[];
}


export class FikoImporterWRL {

    noktalar: THREE.BufferGeometry[] = []
    edges: THREE.BufferGeometry[] = [];
    cizgiNoktalari: THREE.BufferGeometry[] = [];
    yuzeyler: THREE.BufferGeometry[] = [];

    private wasmBridge: FikoWasmBridge;

    public onProgress?: (mesaj: string, progress: number) => void;

    constructor(public sahne?: FikoSahne) {
        this.wasmBridge = FikoWasmBridge.getInstance();
    }

    /**
     * UI thread'i bloke etmemek için async yield fonksiyonu
     */
    private async yieldToMain(): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, 0));
    }

    grpi = 0;
    strti = 0;
    grplinei = 0;
    strtlinei = 0;
    async alDosyadan1(dosya: any): Promise<{ yuzeyler: any, cizgiler: any, vertex: any }> {
        return new Promise((resolve, reject) => {
            this.noktalar = [];
            this.edges = [];
            this.cizgiNoktalari = [];
            this.yuzeyler = []

            this.grpi = 0;
            this.strti = 0;
            this.grplinei = 0;
            this.strtlinei = 0

            let _this = this;

            _this.onProgress?.('WRL dosyası yükleniyor...', 0);

            const loader: VRMLLoader = new VRMLLoader();
            loader.loadAsync(URL.createObjectURL(dosya)).then(function (scene: THREE.Scene) {
                _this.onProgress?.('WRL sahne ayrıştırılıyor...', 20);
                
                scene.remove(scene.children[0]);
                scene.traverse(async (grp: any) => {
                    // console.log(grp)
                    if (grp != undefined && grp.type == "Group" && grp?.name != "" && grp?.children?.length > 0) {

                        for (let i = 0; i < grp.children.length; i++) {
                            const element = grp.children[i];
                            /** NOT:  */
                            if (element.type == "Points") {
                                _this.noktaCozumle(element)
                            }
                            /** NOT: */
                            if (element.type == "LineSegments") {
                                _this.cizgiCozumle(element);
                            }
                            if (element.type == "Mesh") {
                                _this.yuzeyCozumle(element)
                            }

                        }
                    }
                });

                _this.onProgress?.('Geometriler birleştiriliyor...', 60);

                // WASM-optimized geometry merging
                (async () => {
                  try {
                    const mergedNoktalar = await _this.mergeGeometriesOptimized(_this.noktalar);
                    const mergedCizgiNoktalari = await _this.mergeGeometriesOptimized(_this.cizgiNoktalari);

                    _this.onProgress?.('Çizgiler birleştiriliyor...', 75);

                    const mergedCizgiler = await _this.mergeGeometriesOptimized(_this.edges);
                    const mergedYuzeyler = await _this.mergeGeometriesOptimized(_this.yuzeyler);

                    _this.onProgress?.('WRL yükleme tamamlandı', 100);

                    resolve({ yuzeyler: mergedYuzeyler, cizgiler: mergedCizgiler, vertex: mergedCizgiNoktalari });
                  } catch (error) {
                    // Fallback to original Three.js merging
                    const mergedNoktalar = _this.noktalar.length > 0 ? BufferGeometryUtils.mergeGeometries(_this.noktalar) : new THREE.BufferGeometry();
                    const mergedCizgiNoktalari = _this.cizgiNoktalari.length > 0 ? BufferGeometryUtils.mergeGeometries(_this.cizgiNoktalari) : new THREE.BufferGeometry();
                    const mergedCizgiler = _this.edges.length > 0 ? BufferGeometryUtils.mergeGeometries(_this.edges) : new THREE.BufferGeometry();
                    const mergedYuzeyler = _this.yuzeyler.length > 0 ? BufferGeometryUtils.mergeGeometries(_this.yuzeyler) : new THREE.BufferGeometry();
                    resolve({ yuzeyler: mergedYuzeyler, cizgiler: mergedCizgiler, vertex: mergedCizgiNoktalari });
                  }
                })();

                for (var i = scene.children.length - 1; i >= 0; i--) {
                    let obj = scene.children[i];
                    scene.remove(obj);
                }

                // _this.sahne?.anaGosterim?.ciz()
                // _this.sahne?.anaGosterim?.FikoYT.degisti.emit();
            });

        });
    }

    async alUrlden(dosya: any): Promise<{ yuzeyler: any, cizgiler: any, vertex: any }[]> {
        return new Promise((resolve, reject) => {
            this.noktalar = [];
            this.edges = [];
            this.cizgiNoktalari = [];
            this.yuzeyler = []

            this.grpi = 0;
            this.strti = 0;
            this.grplinei = 0;
            this.strtlinei = 0

            let _this = this;
            let _rslt: any = []

            _this.onProgress?.('URL\'den WRL yükleniyor...', 0);

            const loader: VRMLLoader = new VRMLLoader();
            loader.loadAsync(dosya).then(function (scene: THREE.Scene) {
                _this.onProgress?.('WRL sahne ayrıştırılıyor...', 20);

                scene.remove(scene.children[0]);
                scene.traverse(async (grp: any) => {
                    // console.log(grp)
                    if (grp != undefined && grp.type == "Group" && grp?.children?.length > 0) {

                        _this.noktalar = [];
                        _this.edges = [];
                        _this.cizgiNoktalari = [];
                        _this.yuzeyler = []

                        for (let i = 0; i < grp.children.length; i++) {
                            const element = grp.children[i];
                            /** NOT:  */
                            if (element.type == "Points") {
                                _this.noktaCozumle(element)
                            }
                            /** NOT: */
                            if (element.type == "LineSegments") {
                                _this.cizgiCozumle(element);
                            }
                            if (element.type == "Mesh") {
                                _this.yuzeyCozumle(element)
                            }

                        }

                        _this.onProgress?.('Grup geometrileri birleştiriliyor...', 60);

                        // WASM-optimized geometry merging
                        (async () => {
                          try {
                            const mergedNoktalar = await _this.mergeGeometriesOptimized(_this.noktalar);
                            const mergedCizgiNoktalari = await _this.mergeGeometriesOptimized(_this.cizgiNoktalari);

                            _this.onProgress?.('Grup çizgileri birleştiriliyor...', 75);

                            const mergedCizgiler = await _this.mergeGeometriesOptimized(_this.edges);
                            const mergedYuzeyler = await _this.mergeGeometriesOptimized(_this.yuzeyler);

                            _rslt.push({ yuzeyler: mergedYuzeyler, cizgiler: mergedCizgiler, vertex: mergedCizgiNoktalari })
                          } catch (error) {
                            // Fallback to original Three.js merging
                            const mergedNoktalar = _this.noktalar.length > 0 ? BufferGeometryUtils.mergeGeometries(_this.noktalar) : new THREE.BufferGeometry();
                            const mergedCizgiNoktalari = _this.cizgiNoktalari.length > 0 ? BufferGeometryUtils.mergeGeometries(_this.cizgiNoktalari) : new THREE.BufferGeometry();
                            const mergedCizgiler = _this.edges.length > 0 ? BufferGeometryUtils.mergeGeometries(_this.edges) : new THREE.BufferGeometry();
                            const mergedYuzeyler = _this.yuzeyler.length > 0 ? BufferGeometryUtils.mergeGeometries(_this.yuzeyler) : new THREE.BufferGeometry();
                            _rslt.push({ yuzeyler: mergedYuzeyler, cizgiler: mergedCizgiler, vertex: mergedCizgiNoktalari })
                          }
                        })();
                    }
                });

                _this.onProgress?.('WRL yükleme tamamlandı', 100);

                // Biraz bekle async işlemlerin tamamlanması için
                setTimeout(() => {
                    resolve(_rslt);
                }, 100);

                for (var i = scene.children.length - 1; i >= 0; i--) {
                    let obj = scene.children[i];
                    scene.remove(obj);
                }

                // _this.sahne?.anaGosterim?.ciz()
                // _this.sahne?.anaGosterim?.FikoYT.degisti.emit();
            });

        });
    }


    async alDosyadan(dosya: any): Promise<{ yuzeyler: any, cizgiler: any, vertex: any }[]> {
        return new Promise((resolve, reject) => {
            this.noktalar = [];
            this.edges = [];
            this.cizgiNoktalari = [];
            this.yuzeyler = []

            this.grpi = 0;
            this.strti = 0;
            this.grplinei = 0;
            this.strtlinei = 0

            let _this = this;
            let _rslt: any = []

            _this.onProgress?.('WRL dosyası yükleniyor...', 0);

            const loader: VRMLLoader = new VRMLLoader();
            loader.loadAsync(URL.createObjectURL(dosya)).then(function (scene: THREE.Scene) {
                _this.onProgress?.('WRL sahne ayrıştırılıyor...', 20);

                scene.remove(scene.children[0]);
                scene.traverse(async (grp: any) => {
                    if (grp != undefined && grp.type == "Group" && grp?.name != "" && grp?.children?.length > 0) {

                        _this.noktalar = [];
                        _this.edges = [];
                        _this.cizgiNoktalari = [];
                        _this.yuzeyler = []

                        for (let i = 0; i < grp.children.length; i++) {
                            const element = grp.children[i];
                            /** NOT:  */
                            if (element.type == "Points") {
                                _this.noktaCozumle(element)
                            }
                            /** NOT: */
                            if (element.type == "LineSegments") {
                                _this.cizgiCozumle(element);
                            }
                            if (element.type == "Mesh") {
                                _this.yuzeyCozumle(element)
                            }

                        }

                        _this.onProgress?.('Grup geometrileri birleştiriliyor...', 60);

                        // WASM-optimized geometry merging
                        const mergedNoktalar = await _this.mergeGeometriesOptimized(_this.noktalar);
                        const mergedCizgiNoktalari = await _this.mergeGeometriesOptimized(_this.cizgiNoktalari);

                        _this.onProgress?.('Grup çizgileri birleştiriliyor...', 75);

                        const mergedCizgiler = await _this.mergeGeometriesOptimized(_this.edges);
                        const mergedYuzeyler = await _this.mergeGeometriesOptimized(_this.yuzeyler);

                        _rslt.push({ yuzeyler: mergedYuzeyler, cizgiler: mergedCizgiler, vertex: mergedCizgiNoktalari })
                    }
                });

                _this.onProgress?.('WRL yükleme tamamlandı', 100);

                resolve(_rslt);

                for (var i = scene.children.length - 1; i >= 0; i--) {
                    let obj = scene.children[i];
                    scene.remove(obj);
                }


                // _this.sahne?.anaGosterim?.ciz()
                // _this.sahne?.anaGosterim?.FikoYT.degisti.emit();
            });

        });
    }

    async parcala(dosya: any): Promise<{ yuzeyler: any, cizgiler: any, vertex: any }[]> {
        return new Promise(async (resolve, reject) => {
            this.noktalar = [];
            this.edges = [];
            this.cizgiNoktalari = [];
            this.yuzeyler = []

            this.grpi = 0;
            this.strti = 0;
            this.grplinei = 0;
            this.strtlinei = 0

            let _this = this;
            let _rslt: any = []

            _this.onProgress?.('WRL parse ediliyor...', 0);

            let loader: VRMLLoader = new VRMLLoader();
            let scene: THREE.Scene = loader.parse(dosya, null);

            _this.onProgress?.('WRL sahne işleniyor...', 20);

            scene.remove(scene.children[0]);

            _this.noktalar = [];
            _this.edges = [];
            _this.cizgiNoktalari = [];
            _this.yuzeyler = []

            scene.traverse(async (grp: any) => {
                if (grp != undefined && grp.type == "Group" && grp?.name != "" && grp?.children?.length > 0) {


                    for (let i = 0; i < grp.children.length; i++) {
                        const element = grp.children[i];
                        /** NOT:  */
                        if (element.type == "Points") {
                            _this.noktaCozumle(element)
                        }
                        /** NOT: */
                        if (element.type == "LineSegments") {
                            _this.cizgiCozumle(element);
                        }
                        if (element.type == "Mesh") {
                            _this.yuzeyCozumle(element)
                        }

                    }

                }
            });

            _this.onProgress?.('Geometriler birleştiriliyor...', 60);

            // WASM-optimized geometry merging
            let mergedCizgiNoktalari = await _this.mergeGeometriesOptimized(_this.cizgiNoktalari);
            let mergedCizgiler = await _this.mergeGeometriesOptimized(_this.edges);

            _this.onProgress?.('Yüzeyler birleştiriliyor...', 80);

            let mergedYuzeyler = await _this.mergeGeometriesOptimized(_this.yuzeyler);

            _rslt.push({ yuzeyler: mergedYuzeyler, cizgiler: mergedCizgiler, vertex: mergedCizgiNoktalari })

            _this.onProgress?.('WRL parse tamamlandı', 100);

            resolve(_rslt);

            this.noktalar = null;
            this.edges = null;
            this.cizgiNoktalari = null;
            this.yuzeyler = null;

            for (var i = scene.children.length - 1; i >= 0; i--) {
                let obj = scene.children[i];
                scene.remove(obj);
            }
            loader = null
            scene = null;
            mergedCizgiNoktalari.dispose();
            mergedCizgiNoktalari = null;

            mergedCizgiler.dispose();
            mergedCizgiler = null;

            mergedYuzeyler.dispose();
            mergedYuzeyler = null;

            // _this.sahne?.anaGosterim?.ciz()
            // _this.sahne?.anaGosterim?.FikoYT.degisti.emit();

        });
    }



    private async mergeGeometriesOptimized(geometries: THREE.BufferGeometry[]): Promise<THREE.BufferGeometry> {
        if (geometries.length === 0) {
            return new THREE.BufferGeometry();
        }

        // Early return for single geometry
        if (geometries.length === 1) {
            return geometries[0].clone();
        }

        // Try GPU pipeline first (fastest)
        try {
            const gpuPipeline = getGPUImportPipeline();
            const result = await gpuPipeline.gpuMergeGeometries(geometries);
            if (result && result.attributes.position?.count > 0) {
                return result;
            }
        } catch (gpuError) {
            // GPU failed, try WASM
        }

        try {
            // Get WASM bridge instance
            await this.wasmBridge.ensureReady();

            // Check if WASM is available
            if (this.wasmBridge.isWasmReady()) {
                // Convert geometries to WASM format
                const wasmData = await this.convertGeometriesToWasmFormat(geometries);

                // Call WASM merge function
                const mergedData = await this.wasmBridge.mergeGeometriesOptimized(
                    wasmData.vertices,
                    wasmData.indices,
                    wasmData.normals,
                    wasmData.vertexCounts
                );

                // Convert back to Three.js BufferGeometry
                const result = this.createBufferGeometryFromWasmData(mergedData, geometries);
                return result;
            } else {
                throw new Error('WASM not available');
            }
        } catch (error) {
            // Fallback to Three.js merging
            try {

                // BufferGeometryUtils uyarılarını sessize al
                const originalWarn = FikoThreeJsComponent.debugLog;
                console.warn = (...args) => {
                    if (args[0] && args[0].includes && args[0].includes('All geometries must have compatible attributes')) {
                        return; // Bu uyarıyı gösterme
                    }
                    originalWarn.apply(console, args);
                };

                const result = BufferGeometryUtils.mergeGeometries(geometries);

                // Orijinal warn fonksiyonunu geri yükle
                console.warn = originalWarn;

                return result;
            } catch (fallbackError) {
                // Last resort: manual merge
                const result = await this.manualGeometryMerge(geometries);
                return result;
            }
        }
    }

    private async convertGeometriesToWasmFormat(geometries: THREE.BufferGeometry[]): Promise<{
        vertices: number[];
        indices: number[];
        normals: number[];
        vertexCounts: number[];
    }> {
        const allVertices: number[] = [];
        const allIndices: number[] = [];
        const allNormals: number[] = [];
        const vertexCounts: number[] = [];

        let indexOffset = 0;

        for (const geometry of geometries) {
            // Get vertex positions
            const positions = geometry.attributes.position;
            if (positions) {
                const posArray = positions.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < posArray.length; i++) {
                    allVertices.push(posArray[i]);
                }
                vertexCounts.push(posArray.length / 3);
            } else {
                vertexCounts.push(0);
            }

            // Get indices
            const indices = geometry.index;
            if (indices) {
                const idxArray = indices.array as Uint32Array | Uint16Array;
                // Adjust indices for global offset - avoid spread operator
                for (let i = 0; i < idxArray.length; i++) {
                    allIndices.push(idxArray[i] + indexOffset);
                }
                indexOffset += positions ? positions.count : 0;
            }

            // Get normals
            const normals = geometry.attributes.normal;
            if (normals) {
                const normalArray = normals.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < normalArray.length; i++) {
                    allNormals.push(normalArray[i]);
                }
            } else if (positions) {
                // Generate flat normals if not present
                const posCount = positions.array.length;
                const generatedNormals = new Array(posCount).fill(0);
                // Simple flat normal generation (pointing up)
                for (let i = 2; i < posCount; i += 3) {
                    generatedNormals[i] = 1;
                }
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < generatedNormals.length; i++) {
                    allNormals.push(generatedNormals[i]);
                }
            }
        }

        return {
            vertices: allVertices,
            indices: allIndices,
            normals: allNormals,
            vertexCounts: vertexCounts
        };
    }

    noktaCozumle(e: any) {
        this.noktalar.push(e.geometry.clone());
    }

    cizgiCozumle(elm: any) {
        const e = elm as THREE.LineSegments;
        const mat = e.material as THREE.LineBasicMaterial;

        const vertexCount = e.geometry.attributes['position'].count;

        this.cizgiCozumleJS(e, mat, vertexCount);

        this.edges.push(e.geometry.clone());
        this.grplinei++
        this.strtlinei += vertexCount;

        // Extract line endpoints
        const array = e.geometry.clone().attributes['position'].array as Float32Array;
        const point1 = new FikoVektor3D(array[0], array[1], array[2]);
        const point2 = new FikoVektor3D(array[array.length - 3], array[array.length - 2], array[array.length - 1]);
        this.cizgiNoktalari.push(new THREE.BufferGeometry().setFromPoints([point1, point2]));
    }

    private cizgiCozumleJS(e: THREE.LineSegments, mat: THREE.LineBasicMaterial, vertexCount: number) {
        let renkler: number[] = [];
        let seffaflik: number[] = [];
        let grup: number[] = [];
        for (let i = 0; i < vertexCount; i++) {
            renkler.push(mat.color.r, mat.color.g, mat.color.b);
            seffaflik.push(mat.opacity);
            grup.push(this.strtlinei, vertexCount, this.grplinei);
        }
        e.geometry.setAttribute("color", new THREE.Float32BufferAttribute(renkler, 3));
        e.geometry.setAttribute("alpha", new THREE.Float32BufferAttribute(seffaflik, 1));
        e.geometry.setAttribute("grup", new THREE.Float32BufferAttribute(grup, 3));
    }

    yuzeyCozumle(elm: any) {
        const e = elm as THREE.Mesh;
        const mat = e.material as THREE.MeshPhongMaterial;

        const vertexCount = e.geometry.attributes['position'].count;

        this.yuzeyCozumleJS(e, mat, vertexCount);

        // Clone geometry
        this.yuzeyler.push(e.geometry.clone());

        this.grpi++
        this.strti += vertexCount;
    }

    private yuzeyCozumleJS(e: THREE.Mesh, mat: THREE.MeshPhongMaterial, vertexCount: number) {
        let renkler: number[] = [];
        let seffaflik: number[] = [];
        let grup: number[] = [];

        for (let i = 0; i < vertexCount; i++) {
            renkler.push(mat.color.r, mat.color.g, mat.color.b);
            seffaflik.push(mat.opacity);
            grup.push(this.strti, vertexCount, this.grpi);
        }
        e.geometry.setAttribute("color", new THREE.Float32BufferAttribute(renkler, 3));
        e.geometry.setAttribute("alpha", new THREE.Float32BufferAttribute(seffaflik, 1));
        e.geometry.setAttribute("grup", new THREE.Float32BufferAttribute(grup, 3));
    }

    private createBufferGeometryFromWasmData(
        wasmData: number[],
        originalGeometries: THREE.BufferGeometry[]
    ): THREE.BufferGeometry {
        // WASM merge_geometries_optimized returns:
        // [merged_vertices..., merged_normals...]
        // where merged_vertices and merged_normals are concatenated

        if (!wasmData || wasmData.length === 0) {
            // WASM failed, use Three.js fallback
            return BufferGeometryUtils.mergeGeometries(originalGeometries);
        }

        // Calculate total vertices
        const totalVertices = originalGeometries.reduce((sum, geom) => {
            return sum + (geom.attributes.position?.count || 0);
        }, 0);

        // Split wasmData into vertices and normals
        const vertexDataSize = totalVertices * 3;
        const vertices = wasmData.slice(0, vertexDataSize);
        const normals = wasmData.slice(vertexDataSize);

        // Create BufferGeometry
        const geometry = new THREE.BufferGeometry();

        // Set position attribute
        if (vertices.length > 0) {
            geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        }

        // Set normal attribute
        if (normals.length > 0) {
            geometry.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
        } else if (vertices.length > 0) {
            // Compute normals if not provided
            geometry.computeVertexNormals();
        }

        // Create merged indices
        const allIndices: number[] = [];
        let indexOffset = 0;

        for (const geom of originalGeometries) {
            if (geom.index) {
                const indices = geom.index.array as Uint32Array | Uint16Array;
                for (let i = 0; i < indices.length; i++) {
                    allIndices.push(indices[i] + indexOffset);
                }
            }
            indexOffset += geom.attributes.position?.count || 0;
        }

        // Set merged indices
        if (allIndices.length > 0) {
            geometry.setIndex(new THREE.Uint32BufferAttribute(allIndices, 1));
        }

        // Directly copy attributes from original geometries to preserve them
        const allColors: number[] = [];
        const allAlphas: number[] = [];
        const allGroups: number[] = [];

        for (const geom of originalGeometries) {
            // Copy colors
            if (geom.attributes.color) {
                const colors = geom.attributes.color.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < colors.length; i++) {
                    allColors.push(colors[i]);
                }
            }

            // Copy alphas
            if (geom.attributes.alpha) {
                const alphas = geom.attributes.alpha.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < alphas.length; i++) {
                    allAlphas.push(alphas[i]);
                }
            }

            // Copy groups (IMPORTANT for highlight!)
            if (geom.attributes.grup) {
                const groups = geom.attributes.grup.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < groups.length; i++) {
                    allGroups.push(groups[i]);
                }
            }
        }

        // Set attributes directly on geometry
        if (allColors.length > 0) {
            geometry.setAttribute('color', new THREE.Float32BufferAttribute(allColors, 3));
        }

        if (allAlphas.length > 0) {
            geometry.setAttribute('alpha', new THREE.Float32BufferAttribute(allAlphas, 1));
        }

        if (allGroups.length > 0) {
            geometry.setAttribute('grup', new THREE.Float32BufferAttribute(allGroups, 3));
        }

        // Compute bounding box and sphere
        geometry.computeBoundingBox();
        geometry.computeBoundingSphere();

        return geometry;
    }

    private mergeAttributes(
        mergedGeometry: THREE.BufferGeometry,
        originalGeometries: THREE.BufferGeometry[]
    ): void {
        const allColors: number[] = [];
        const allAlphas: number[] = [];
        const allGroups: number[] = [];

        for (const geometry of originalGeometries) {
            const vertexCount = geometry.attributes.position?.count || 0;

            // Merge colors
            if (geometry.attributes.color) {
                const colors = geometry.attributes.color.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < colors.length; i++) {
                    allColors.push(colors[i]);
                }
            }

            // Merge alphas
            if (geometry.attributes.alpha) {
                const alphas = geometry.attributes.alpha.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < alphas.length; i++) {
                    allAlphas.push(alphas[i]);
                }
            }

            // Merge groups - IMPORTANT for highlight!
            if (geometry.attributes.group) {
                const groups = geometry.attributes.group.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < groups.length; i++) {
                    allGroups.push(groups[i]);
                }
            }
        }

        // Set merged attributes with proper names
        if (allColors.length > 0) {
            mergedGeometry.setAttribute('color', new THREE.Float32BufferAttribute(allColors, 3));
        }

        if (allAlphas.length > 0) {
            mergedGeometry.setAttribute('alpha', new THREE.Float32BufferAttribute(allAlphas, 1));
        }

        if (allGroups.length > 0) {
            mergedGeometry.setAttribute('grup', new THREE.Float32BufferAttribute(allGroups, 3));
        }
    }

    buildHierarchy(obj: any): FikoWRLHiyerarsi {
        const node: FikoWRLHiyerarsi = {
            name: obj.name || '',
            type: obj.type,
            children: []
        };

        if (obj.children && obj.children.length > 0) {
            for (const child of obj.children) {
                node.children.push(this.buildHierarchy(child));
            }
        }

        return node;
    }

    async alDosyadanHiyerarsi(dosya: any): Promise<{ yuzeyler: any, cizgiler: any, vertex: any, hiyerarsi: FikoWRLHiyerarsi[] }> {
        return new Promise((resolve, reject) => {
            this.noktalar = [];
            this.edges = [];
            this.cizgiNoktalari = [];
            this.yuzeyler = [];
            this.grpi = 0;
            this.strti = 0;
            this.grplinei = 0;
            this.strtlinei = 0;

            const _this = this;

            _this.onProgress?.('WRL hiyerarşi yükleniyor...', 0);

            const loader: VRMLLoader = new VRMLLoader();
            loader.loadAsync(URL.createObjectURL(dosya)).then(async scene => {

                _this.onProgress?.('WRL hiyerarşi ayrıştırılıyor...', 20);

                const hiyerarsi: FikoWRLHiyerarsi[] = [];

                const traverseAndBuild = (obj: any) => {
                    // Geometrileri çöz
                    if (obj.type == "Points") this.noktaCozumle(obj);
                    if (obj.type == "LineSegments") this.cizgiCozumle(obj);
                    if (obj.type == "Mesh") this.yuzeyCozumle(obj);

                    // Hiyerarşi node
                    const node: FikoWRLHiyerarsi = {
                        name: obj.name || '',
                        type: obj.type,
                        children: []
                    };

                    if (obj.children && obj.children.length > 0) {
                        for (const child of obj.children) {
                            node.children.push(traverseAndBuild(child));
                        }
                    }

                    return node;
                }

                for (const child of scene.children) {
                    hiyerarsi.push(traverseAndBuild(child));
                }

                _this.onProgress?.('Hiyerarşi geometrileri birleştiriliyor...', 60);

                const mergedNoktalar = await _this.mergeGeometriesOptimized(_this.noktalar);
                const mergedCizgiNoktalari = await _this.mergeGeometriesOptimized(_this.cizgiNoktalari);

                _this.onProgress?.('Hiyerarşi çizgileri birleştiriliyor...', 80);

                const mergedCizgiler = await _this.mergeGeometriesOptimized(_this.edges);
                const mergedYuzeyler = await _this.mergeGeometriesOptimized(_this.yuzeyler);

                _this.onProgress?.('WRL hiyerarşi tamamlandı', 100);

                resolve({
                    yuzeyler: mergedYuzeyler,
                    cizgiler: mergedCizgiler,
                    vertex: mergedCizgiNoktalari,
                    hiyerarsi
                });

            }).catch(err => reject(err));
        });
    }

    private async manualGeometryMerge(geometries: THREE.BufferGeometry[]): Promise<THREE.BufferGeometry> {
        const mergedGeometry = new THREE.BufferGeometry();
        const allVertices: number[] = [];
        const allIndices: number[] = [];
        const allColors: number[] = [];
        const allAlphas: number[] = [];
        const allGroups: number[] = [];

        let vertexOffset = 0;
        const CHUNK_SIZE = 5; // Her 5 geometry'de bir UI'a kontrol ver

        for (let gIdx = 0; gIdx < geometries.length; gIdx++) {
            const geometry = geometries[gIdx];
            // Clone to avoid modifying original
            const clonedGeometry = geometry.clone();

            // Get positions
            if (clonedGeometry.attributes.position) {
                const positions = clonedGeometry.attributes.position.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < positions.length; i++) {
                    allVertices.push(positions[i]);
                }
            }

            // Get and adjust indices
            if (clonedGeometry.index) {
                const indices = clonedGeometry.index.array as Uint32Array | Uint16Array;
                for (let i = 0; i < indices.length; i++) {
                    allIndices.push(indices[i] + vertexOffset);
                }
            }

            // Get colors
            if (clonedGeometry.attributes.color) {
                const colors = clonedGeometry.attributes.color.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < colors.length; i++) {
                    allColors.push(colors[i]);
                }
            }

            // Get alphas
            if (clonedGeometry.attributes.alpha) {
                const alphas = clonedGeometry.attributes.alpha.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < alphas.length; i++) {
                    allAlphas.push(alphas[i]);
                }
            }

            // Get groups
            if (clonedGeometry.attributes.group) {
                const groups = clonedGeometry.attributes.group.array as Float32Array;
                // Avoid stack overflow: use loop instead of spread operator
                for (let i = 0; i < groups.length; i++) {
                    allGroups.push(groups[i]);
                }
            }

            vertexOffset += clonedGeometry.attributes.position?.count || 0;

            // UI blokajını önle: Her chunk'ta UI'a kontrol ver
            if ((gIdx + 1) % CHUNK_SIZE === 0 && gIdx < geometries.length - 1) {
                await this.yieldToMain();
            }
        }

        // Set merged attributes
        if (allVertices.length > 0) {
            mergedGeometry.setAttribute('position', new THREE.Float32BufferAttribute(allVertices, 3));
        }

        if (allIndices.length > 0) {
            mergedGeometry.setIndex(new THREE.Uint32BufferAttribute(allIndices, 1));
        }

        if (allColors.length > 0) {
            mergedGeometry.setAttribute('color', new THREE.Float32BufferAttribute(allColors, 3));
        }

        if (allAlphas.length > 0) {
            mergedGeometry.setAttribute('alpha', new THREE.Float32BufferAttribute(allAlphas, 1));
        }

        if (allGroups.length > 0) {
            mergedGeometry.setAttribute('group', new THREE.Float32BufferAttribute(allGroups, 3));
        }

        // Compute missing attributes
        mergedGeometry.computeBoundingBox();
        mergedGeometry.computeBoundingSphere();

        if (!mergedGeometry.attributes.normal) {
            mergedGeometry.computeVertexNormals();
        }

        return mergedGeometry;
    }
}